import { COLORS } from '@btime/constants'
import React from 'react'

import { getLocalStorageItem } from '../../../utils/helpers/localStorage'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'

const UsersRootPage = () => {
  const navigate = useNavigation()

  React.useEffect(() => {
    const urlSufix = getLocalStorageItem('USERS_LAST_SCREEN') || 'list'
    navigate(`/users/${urlSufix}`)
  }, [])

  return <SideMenuTemplate bgColor={COLORS.white}></SideMenuTemplate>
}

export default UsersRootPage
